export default [
  {
    ID: 11,
    size: "300-250",
    count: 3,
    base_price: 12000,
    price: 4000,
    hilite_commission: 0,
    publisher_right: 0,
    allow_alternative: true,
    score_alternative: 4000,
    state: "در حال انتظار",
    active: true,
    created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۵",
  },
  {
    ID: 12,
    size: "180-600",
    count: 2,
    base_price: 8000,
    price: 4000,
    hilite_commission: 0,
    publisher_right: 0,
    allow_alternative: true,
    score_alternative: 2000,
    state: "تایید موقت و ارسال پیشنهاد به نمایش دهنده",
    active: true,
    created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۵",
    message:"با سلام.حق نمایش دهنده ۳۸۰۰ و کمسیسون هایلایت ۲۰۰ است.",
  },
  {
    ID: 13,
    size: "970-90",
    count: 2,
    base_price: 10000,
    price: 5000,
    hilite_commission: 0,
    publisher_right: 0,
    allow_alternative: true,
    score_alternative: 5000,
    state: "رد شدن پیشنهاد از طرف نمایش دهنده",
    active: true,
    created_at: "۱۲:۲۱:۴۴ ۱۴۰۱/۰۴/۲۵",
  },
];
